import React from "react";
import tw from "twin.macro";
import OrgCard from "./org-card";
import UWLogoSvg from "./uw-logo.svg";
import { Hyperlink } from "../section";

const UWCard = tw(OrgCard.Base)`ml-auto`;
const UWPiHeading = tw(OrgCard.PiHeadingBase)`border-red-900 text-red-900`;

const uwurl =
  "https://biostat.wiscweb.wisc.edu/research/clinical-trials/data-coordinating-center/";

const UW = () => (
  <UWCard>
    <OrgCard.LogoContainer href={uwurl}>
      <OrgCard.Logo
        src={UWLogoSvg}
        alt="University of Wisconsin, School of Medicine and Public Health, Department of Biostatistics and Medical Informatics"
      />
    </OrgCard.LogoContainer>
    <OrgCard.Body>
      <OrgCard.Paragraph>
        The University of Wisconsin{" "}
        <Hyperlink href={uwurl}>Data Coordinating Center (DCC)</Hyperlink> was
        established in 2016 as a component of the Clinical Trials Program in the
        Department of Biostatistics and Medical Informatics (BMI) in the UW
        School of Medicine and Public Health.
      </OrgCard.Paragraph>
      <OrgCard.Paragraph>
        The DCC supports and is engaged in collaborative clinical research
        projects which are NIH- or industry-funded data coordinating centers.
      </OrgCard.Paragraph>
      <OrgCard.Paragraph>
        The DCC plays a critical role in coordinating and implementing large
        multi-center randomized controlled trials (RCTs) and other types of
        clinical research studies, bringing expertise in planning, conduct,
        monitoring, analysis and reporting and in data management, quality
        control and quality assurance, and information technology support for
        trial monitoring and communication, all needed to complement the
        clinical investigators&apos; content expertise.
      </OrgCard.Paragraph>
    </OrgCard.Body>
    <OrgCard.Pi>
      <UWPiHeading>KyungMann Kim, PhD</UWPiHeading>
      <OrgCard.Paragraph>
        KyungMann Kim, PhD is the DMACC PI and Director of the Administrative
        and Coordinating Unit. Dr. Kim is currently Professor of Biostatistics
        and Medical Informatics at the University of Wisconsin-Madison. He is an
        elected Fellow of the American Association for the Advancement of
        Science and the Society for Clinical Trials as well as the American
        Statistical Association.
      </OrgCard.Paragraph>
    </OrgCard.Pi>
  </UWCard>
);

export default UW;
